document.addEventListener('DOMContentLoaded', () => {
  const balanceWidgets = [...document.querySelectorAll('[data-metraink-header-balance]')];

  let balanceRequest = 0;
  // Diagnostic category only: never store customer identity, amounts or tokens.
  const balanceState = (value) => balanceWidgets.forEach(widget => widget.setAttribute('data-metraink-balance-state', value));
  const hideBalances = () => balanceWidgets.forEach((widget) => {
    widget.hidden = true;
    widget.removeAttribute('aria-label');
    widget.querySelector('[data-metraink-balance-items]')?.replaceChildren();
  });
  const refreshBalances = () => {
    if (!balanceWidgets.length) return;
    const request = ++balanceRequest;
    hideBalances();
    balanceState('loading');
    const rootUrl = window.Shopify?.routes?.root || '/';
    return fetch(`${rootUrl}apps/metraink/api/customer-balance`, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' },
    })
      .then((response) => {
        if (!response.ok) {
          if (request === balanceRequest) balanceState(`http-${response.status}`);
          throw new Error('Balance unavailable');
        }
        return response.json();
      })
      .then((payload) => {
        if (request !== balanceRequest) return;
        if (!payload?.authenticated || !payload?.available) {
          balanceState(payload?.disabled ? 'disabled' : !payload?.authenticated ? 'unauthenticated' : 'unavailable');
          return;
        }
        balanceState('available-empty');

        balanceWidgets.forEach((widget) => {
          const balances = [
            { ...payload.textile, label: widget.dataset.textileLabel || 'Textil' },
            { ...payload.textile75, label: widget.dataset.textile75Label || 'DTF 76' },
            { ...payload.uv, label: widget.dataset.uvLabel || 'UV' },
          ].filter((balance) => Number.isFinite(balance.balance) && balance.balance >= 0
            && Number.isFinite(balance.total) && balance.total >= balance.balance
            && (balance.balance > 0 || (payload.mode === 'manual-bono-v1' && balance.total > 0)));
          if (!balances.length) return;
          balanceState('available-balance');

          const items = widget.querySelector('[data-metraink-balance-items]');
          if (!items) return;
          items.replaceChildren();

          balances.forEach((balance) => {
            const remaining = Math.max(0, Number(balance.balance) || 0);
            const total = Math.max(remaining, Number(balance.total) || 0, 1);
            const percentage = Math.min(100, Math.max(0, (remaining / total) * 100));
            const shipments = Math.max(0, Number(balance.shipments) || 0);
            const reserved = Math.max(0, Number(balance.reserved) || 0);
            const item = document.createElement('span');
            item.className = 'metraink-header__balance-item';

            const copy = document.createElement('span');
            copy.className = 'metraink-header__balance-copy';
            const label = document.createElement('span');
            label.textContent = balance.label;
            const value = document.createElement('strong');
            value.textContent = `${remaining} m`;
            copy.append(label, value);

            const track = document.createElement('span');
            track.className = 'metraink-header__balance-track';
            track.setAttribute('aria-hidden', 'true');
            const fill = document.createElement('span');
            fill.style.width = `${percentage}%`;
            track.append(fill);
            const details = document.createElement('small');
            details.className = 'metraink-header__balance-details';
            details.textContent = `${shipments} ${widget.dataset.shipmentsLabel || 'envíos disponibles'}`;
            if (reserved > 0) details.textContent += ` · ${reserved} m ${widget.dataset.reservedLabel || 'reservados'}`;
            if (remaining === 0 && reserved === 0) details.textContent += ` · ${widget.dataset.emptyLabel || 'Metros agotados'}`;
            item.append(copy, track, details);
            items.append(item);
          });

          const summary = balances.map((balance) => `${balance.label}: ${balance.balance} m, ${Math.max(0, Number(balance.shipments) || 0)} ${widget.dataset.shipmentsLabel || 'envíos disponibles'}`).join(', ');
          widget.setAttribute('aria-label', `${widget.dataset.accessibilityLabel || 'Saldo de bonos'}: ${summary}`);
          widget.hidden = false;
        });
      })
      .catch(() => {
        if (request === balanceRequest && balanceWidgets.some(widget => widget.getAttribute('data-metraink-balance-state') === 'loading')) balanceState('request-failed');
      });
  };
  refreshBalances();
  window.addEventListener('pagehide', () => { ++balanceRequest; hideBalances(); });
  window.addEventListener('pageshow', (event) => { if (event.persisted) refreshBalances(); });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') refreshBalances();
    else { ++balanceRequest; hideBalances(); }
  });
  window.addEventListener('metraink:bonus-updated', refreshBalances);

  const root = document.querySelector('.metraink-home');
  if (!root) return;

  const header = root.querySelector('.metraink-header');
  const navigation = header?.querySelector('nav');
  const menuToggle = header?.querySelector('.metraink-menu-toggle');
  let headerFrame = 0;

  const closeNavigation = () => {
    navigation?.classList.remove('open');
    menuToggle?.setAttribute('aria-expanded', 'false');
    menuToggle?.setAttribute('aria-label', 'Abrir navegación');
  };

  const updateHeader = () => {
    headerFrame = 0;
    if (!header) return;

    const isScrolled = window.scrollY > 40;
    header.classList.toggle('scrolled', isScrolled);

    let theme = 'dark';
    if (isScrolled) {
      const sampleY = Math.min(48, window.innerHeight - 1);
      const sampleX = Math.round(window.innerWidth / 2);
      const surface = document.elementsFromPoint(sampleX, sampleY)
        .find((element) => !element.closest('.metraink-header'))
        ?.closest('[data-header-theme]');
      theme = surface?.getAttribute('data-header-theme') || 'dark';
    }

    header.classList.toggle('theme-light', theme === 'light');
    header.classList.toggle('theme-dark', theme !== 'light');
  };

  const requestHeaderUpdate = () => {
    if (headerFrame) return;
    headerFrame = window.requestAnimationFrame(updateHeader);
  };

  menuToggle?.addEventListener('click', () => {
    const isOpen = navigation?.classList.toggle('open') || false;
    menuToggle.setAttribute('aria-expanded', String(isOpen));
    menuToggle.setAttribute('aria-label', isOpen ? 'Cerrar navegación' : 'Abrir navegación');
  });

  navigation?.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeNavigation));
  window.addEventListener('scroll', requestHeaderUpdate, { passive: true });
  window.addEventListener('resize', () => {
    closeNavigation();
    requestHeaderUpdate();
  });
  updateHeader();

  const panels = [...root.querySelectorAll('[data-guide-panel]')];
  const cards = [...root.querySelectorAll('[data-guide-card]')];

  const closeGuides = () => {
    panels.forEach((panel) => { panel.hidden = true; });
    cards.forEach((card) => card.classList.remove('active'));
  };

  root.querySelectorAll('[data-guide-open]').forEach((button) => {
    button.addEventListener('click', () => {
      const guide = button.getAttribute('data-guide-open');
      const target = root.querySelector(`[data-guide-panel="${guide}"]`);
      const wasOpen = target && !target.hidden;
      closeGuides();
      if (!target || wasOpen) return;
      target.hidden = false;
      root.querySelector(`[data-guide-card="${guide}"]`)?.classList.add('active');
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  root.querySelectorAll('[data-guide-close]').forEach((button) => {
    button.addEventListener('click', closeGuides);
  });
});

